// import { _DisposeViewRepeaterStrategy, _VIEW_REPEATER_STRATEGY } from '@angular/cdk/collections';
import {
    CdkTable,
    CDK_TABLE,
    STICKY_POSITIONING_LISTENER,
    HeaderRowOutlet,
    DataRowOutlet,
    NoDataRowOutlet,
    FooterRowOutlet
} from '@angular/cdk/table';
import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';

/** This is a wrapper for the material CdkTable component */
@Component({
    selector: 'ap-table, table[ap-table]',
    exportAs: 'apTable',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        { provide: CDK_TABLE, useExisting: ApTableComponent },
        // { provide: _VIEW_REPEATER_STRATEGY, useClass: _DisposeViewRepeaterStrategy },
        // Prevent nested tables from seeing this table's StickyPositioningListener.
        { provide: STICKY_POSITIONING_LISTENER, useValue: null }
    ],
    imports: [HeaderRowOutlet, DataRowOutlet, NoDataRowOutlet, FooterRowOutlet]
})
export class ApTableComponent<T> extends CdkTable<T> {
    @HostBinding('class.ap-table') apTable = true;
    @HostBinding('id') protected id: string = `table${Math.floor(Math.random() * 1e6)}`;
    @HostBinding('class.ap-responsive-table')

    /**
     * Is the table responsive?
     * Defaults to true
     */
    @Input()
    public responsive = true;

    private cells: string[] = [];

    constructor() {
        super();
    }

    /**
     * Get and id for the cell.
     * CellId's set from the template are stored.
     * CellId's referenced from `this.getHeaders` are not stored and should use the private method.
     * @param {number} colIndex The index of the column
     * @param {number} rowIndex The index of the row
     * @param {boolean} hidden Cells that are not in <thead> are initially hidden and need the row id
     */
    getAndStoreCellID(colIndex: number, rowIndex = -1, hidden = false): string {
        const colId = this.getCellID(colIndex, rowIndex, hidden);
        this.cells.push(colId);
        return colId;
    }

    /**
     * Retreive the `[headers]` attribute value for a cell.
     * Since we don't know in advance if a hidden header cell is defined, we filter against cellId's stored in `this.cells`.
     * @param {number} colIndex
     * @param {number} rowIndex
     */
    getHeaders(colIndex: number, rowIndex: number): string {
        return [this.getCellID(colIndex), this.getCellID(colIndex, rowIndex, true)].filter((id) => this.cells.includes(id)).join(' ');
    }

    /**
     * Get and id for the cell.
     * @param {number} colIndex The index of the column
     * @param {number} rowIndex The index of the row
     * @param {boolean} hidden Cells that are not in <thead> are initially hidden and need the row id
     */
    private getCellID(colIndex: number, rowIndex = -1, hidden = false): string {
        return `${this.id}_th${colIndex}${hidden ? `_tr${rowIndex}` : ''}`;
    }
}
